import React, { useContext } from 'react'
import { Fullscreen, FullscreenExit } from '@material-ui/icons'
import listContext from '../../../Common/context/context'

const FullscreenButton = () => {

    const { focusedMode, setFocusedMode } = useContext(listContext)

    return (
        <>
            <button title={!focusedMode ? 'Enter full screen mode' : 'Exit full screen mode'} data-testid="test-btn-focusMode" className="p-2 btn rounded-full" onClick={() => setFocusedMode(!focusedMode)} >
                {!focusedMode ? <Fullscreen fontSize="small"></Fullscreen>
                    : <FullscreenExit fontSize="small"></FullscreenExit>}
            </button>
        </>
    )
}

export default FullscreenButton
